var map = {
	"./fotos_1.jpg": "41b0",
	"./fotos_2.jpg": "923b",
	"./fotos_3.jpg": "951d",
	"./fotos_4.jpg": "5615",
	"./fotos_5.jpg": "ce64",
	"./fotos_6.jpg": "fe42",
	"./fotos_7.jpg": "a5e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d99";